import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ResizableColumns from '../../../components/FallComponents/ResizableColumns/ResizableColumns'
import AllTicketsAndInvoicesPage from '../../../components/FallComponents/TicketsAndInvoicesPage/AllTicketsAndInvoicesPage'
import { useFilter } from '../../../hooks/useFilter'
import TicketsAndInvoicesController from '../../FallControllers/TicketsAndInvoicesController'
import isEmpty from 'is-empty'

const TicketsAndInvoicesPage = (props, context) => {

    const { userInfo } = props;

    const [changeLimit, setChangeLimit] = useState(false);
    const [loading, setLoading] = useState(true);
    const [withRightSection, setWithRightSection] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [rows, setRows] = useState([]);

    const {
        filterConfig,
        filterSearch,
        offset,
        showingTo,
        changePage,
        onChangeLimit,
        resetFilters,
        setFilterSearch
    } = useFilter({ totalRows });

    const initialConfig = () => {
        resetFilters(20)
        setChangeLimit(true);
    }

    const handleLoadTicketsAndInvoices = () => {
        TicketsAndInvoicesController.handleAllTicketsAndInvoices({
            userInfo,
            filterConfig,
            filterSearch,
            setLoading,
            setRows,
            setTotalRows
        })
    }

    const handleDeleteCreditNote = async (data) => {
        await TicketsAndInvoicesController.handleCreateCreditNoteSubmit({
            userInfo,
            data,
            handleLoadTicketsAndInvoices
        })
    }

    const handleDownload = () => {
        TicketsAndInvoicesController.handleDownloadAllTicketsInvoices({
            userInfo,
            rows
        })
    }

    useEffect(() => {
        if (!changeLimit) initialConfig();
        if (!isEmpty(userInfo) && changeLimit) handleLoadTicketsAndInvoices();
    }, [userInfo, filterConfig, filterSearch])

    return (
        <div className="beta-content-container">
            <ResizableColumns
                withRightSection={withRightSection}
                minWidth='500px'
                childrenOne={
                    <AllTicketsAndInvoicesPage
                        loading={loading}
                        setFilterSearch={setFilterSearch}
                        onChangeLimit={onChangeLimit}
                        filterConfig={filterConfig}
                        totalRows={totalRows}
                        offset={offset}
                        showingTo={showingTo}
                        changePage={changePage}
                        rows={rows}
                        withRightSection={withRightSection}
                        initialConfig={initialConfig}
                        context={context}
                        handleDeleteCreditNote={handleDeleteCreditNote}
                        handleDownload={handleDownload}
                    />
                }
            />
        </div>
    )
};

const mapStateToProps = ({ user: { userInfo } }) => {
    return { userInfo };
};

TicketsAndInvoicesPage.contextTypes = {
    t: PropTypes.func.isRequired
};

export default connect(mapStateToProps)(TicketsAndInvoicesPage);